const b = (r) => r.map((t) => {
  var o, u, a, _, l, n;
  return {
    ...t,
    ctaButton1: {
      ...t.cta_button_1,
      buttonColour: (o = t.cta_button_1) == null ? void 0 : o.button_colour,
      textColour: (u = t.cta_button_1) == null ? void 0 : u.text_colour,
      urlPath: (a = t.cta_button_1) == null ? void 0 : a.url_path
    },
    ctaButton2: {
      ...t.cta_button_2,
      buttonColour: (_ = t.cta_button_2) == null ? void 0 : _.button_colour,
      textColour: (l = t.cta_button_2) == null ? void 0 : l.text_colour,
      urlPath: (n = t.cta_button_2) == null ? void 0 : n.url_path
    },
    mobileImage: t.mobile_image,
    tabletImage: t.tablet_image,
    urlPath: t.url_path
  };
});
export {
  b as mapStrapiBanner
};
